import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the window to the top whenever the route changes.
 * Mount this once inside <BrowserRouter> — it has no UI of its own.
 *
 * Why this exists: React Router preserves the scroll position from the
 * previous page when you navigate via <Link>, so clicking "Career Roadmap"
 * from a scrolled-down landing page opens the new page already mid-fold.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use 'instant' (not 'smooth') so users don't see a flash of the bottom
    // of the new page before it scrolls up.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
